// extracted by mini-css-extract-plugin
export default {"span_in_input":"VerificationNum_span_in_input__-vy6o"};